import React from 'react';
import { DataList, CustomModal, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import { LIST_ENTITY_NAMES } from 'constant';
import { Button, KIND, SIZE } from 'baseui/button';
import useDashboardActions from 'pages/userProfile/useUserProfileActions';
import { columnConfigs } from './listConfig';
import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

const KindRewardList: React.FC<{}> = () => {
	const {
		getAllKindRewardData,
		filters,
		showLoader,
		setShowLoader,
		forceUpdate,
		handleFilterModalOpen,
		handleRewardModalOpen,
		creditKindRewardToTheUser
	} = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setShowLoader,
		filters,
		handleRewardModalOpen,
		creditKindRewardToTheUser
	});
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<Button kind={KIND.primary} size={SIZE.compact} onClick={handleFilterModalOpen}>
					Change Filters
				</Button>
			</div>
			<DataList
				fetchData={getAllKindRewardData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.KIND_REWARDS}
				height='calc(100vh - 220px)'
				filterable={false}
				searchable={false}
				globalForceUpdate={forceUpdate}
			/>
			<CustomModal />
		</>
	);
};

export default KindRewardList;
